import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Main from '../components/Main';
import Helmet from 'react-helmet';
import { GoogleAdResponsiveUnitDesktop, GoogleAdResponsiveUnitMobile } from '../components/GoogleAdsRU';
import { isAmpPage, AMPPrefix } from '../components/utils';
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n';
import { IntlProvider } from 'react-intl';
import 'intl';
import 'intl/locale-data/jsonp/en';

import 'intl/locale-data/jsonp/it';
import './all.sass';
import '../styles/layout.scss';

const getIdJsonUrl = (id, langKey, jsonData) => {
  if (jsonData?.slug) {
    return jsonData?.slug?.toLowerCase();
  }

  if (id !== 'undefined') {
    
    let res;
    switch (langKey) {
      //we get the name of the page according the id
      case 'en':
        res = jsonData[id].en;
        break;
      case 'it':
        res = jsonData[id].it;
        break;
      case 'ar':
        res = jsonData[id].ar;
        break;
      default:
        return ' ';
    }
    return res;
  } else {
    console.log('missed id in the getIdUrl() function!');
  }
};

const setLangsMenu = (langsMenu, id, jsonData) => {
  if (id !== 'undefined') {
    langsMenu[0].link = `/en/`;
    langsMenu[1].link = `/ar/`;
    if(Array.isArray(jsonData) || jsonData?.type)
    {
      langsMenu[0].link += getIdJsonUrl(id, 'en', jsonData);
      langsMenu[1].link += getIdJsonUrl(id, 'ar', jsonData);
    }
  } else {
    console.log('missed id in the setLangsMenu() function!');
  }
};

// // add concatenated locale data
// addLocaleData([...en, ...it, ...ar]);

class TemplateWrapper extends Component {
  constructor(props) {
    super(props);
    this.children = this.props.children;
    const data = this.props.data;
    this.description = data?.markdownRemark?.frontmatter?.description || data?.description;
    const jsonData = this.props.jsonData;
    this.className = this.props.className;
    const location = this.props.location;
    this.title = data?.markdownRemark?.frontmatter?.title || data?.title;
    const url = location?.pathname || '';
    const { langs, defaultLangKey } = require('../data/languages');
    this.langKey = getCurrentLangKey(langs, defaultLangKey, url.replace(AMPPrefix, ''));
    this.homeLink = `/${this.langKey}/`;
    this.langsMenu = getLangs(langs, this.langKey, getUrlForLang(this.homeLink, url));
    const id_article = jsonData?.type || data?.markdownRemark?.frontmatter?.id;
    const id = id_article === 'horoscope' ? id_article : Number(id_article) - 1;

    this.isArabic = this.langKey === 'ar';
    this.isAMPPage = isAmpPage(url); // ToDo: improve that
    //finally here we set the desired url...
    setLangsMenu(this.langsMenu, id, jsonData);

    // get the appropriate message file based on langKey
    // at the moment this assumes that langKey will provide us
    // with the appropriate language code
    this.i18nMessages = require(`../data/messages/${this.langKey}`);
  }
  render() {
    return (
      <IntlProvider locale={this.langKey} messages={this.i18nMessages}>
        <React.Fragment>
          {!this.isAMPPage && (
            <Helmet>
              <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
              <html lang={this.langKey}></html>
            </Helmet>
          )}
          {this.isAmpPage && (
            <>
              <Helmet>
                <script async custom-element="amp-auto-ads" src="https://cdn.ampproject.org/v0/amp-auto-ads-0.1.js"></script>
              </Helmet>
              <amp-auto-ads type="adsense" data-ad-client="ca-pub-8740909081146912"></amp-auto-ads>
            </>
          )}

          <Header langKey={this.langKey} langs={this.langsMenu} menu={this.menuTree} />
          <div className={`container ${this.isArabic ? 'ara' : ''}`}>
            <div class="center-content columns is-marginless">
              <Main key="app-main" className={`${this.className} column is-four-fifths`}>
                {this.children}
              </Main>
              <div class="is-full is-hidden-tablet ads">
                <GoogleAdResponsiveUnitMobile />
              </div>
              <div class="column is-hidden-mobile ads">
                <GoogleAdResponsiveUnitDesktop />
              </div>
            </div>
          </div>
          <Footer langKey={this.langKey} />
        </React.Fragment>
      </IntlProvider>
    );
  }
}

export default TemplateWrapper;
